module.exports = __webpack_public_path__ + "static/media/ic_arrow_drop_down_selected.42724264.svg";